import algoliasearch from 'algoliasearch/lite'

import logger from '@logger'

export const getProductsWithWarranty = ({
  algoliaResult,
  getWarrantyByProduct,
}) => {
  const hitProducts = algoliaResult.reduce((acc, currentResult) => {
    const products = currentResult.hits

    return [...acc, ...products]
  }, [])

  return hitProducts.map((product) => ({
    ...product,
    warranty: getWarrantyByProduct(product),
  }))
}

export const findResultsFromQuery = async ({
  ALGOLIA_ID,
  ALGOLIA_KEY,
  query,
}) => {
  const client = algoliasearch(ALGOLIA_ID, ALGOLIA_KEY)

  try {
    const { results } = await client.search([query])

    return results
  } catch (error) {
    logger.error('Algolia calls for CMS for single query', { error })

    return []
  }
}
